"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicService = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class TopicService {
    constructor(meStore, authStore) {
        this.meStore = meStore;
        this.authStore = authStore;
        this.meStore = meStore;
        this.authStore = authStore;
    }
    async generateTopic(topicInfo, topicType) {
        const { templateId, edgeId, sourceNodeId } = topicInfo || {};
        const me = await this.meStore.get();
        const id = me.id ?? this.authStore.state.guestToken;
        const wsuid = (0, is_blank_1.default)(templateId) ? "" : templateId + "_";
        const nodeid = (0, is_blank_1.default)(sourceNodeId) ? "" : "_nodeid_" + sourceNodeId;
        return `/studios/${id}/wsuid_${wsuid}${edgeId}${nodeid}/${topicType}/${Date.now()}`;
    }
}
exports.TopicService = TopicService;
